<template>
  <div id="about__enem" class="pb-4 fade-in-up">
    <div id="header">
      <div class="img__header">
        <div class="bg__escuro"></div>
        <div class="bg__title">
          <b-container fluid="lg">
            <h2 class="text-title">ENEM</h2>
          </b-container>
        </div>
      </div>
    </div>

    <BreadSistema class="bread__about" />

    <b-container fluid="lg" class="pt-4 pb-4">
      <div class="box-text">
        <div class="content-text">
          <p class="lead font-weight-light">Mais do que revisar conteúdos, o material propõe o desenvolvimento das
            habilidades e competências exigidas pelo ENEM, por meio do trabalho com os exercícios sempre atualizados
            desse vestibular.</p>
          <p class="mt-3">Trata-se de material estratégico,
            que pode ser utilizado como complemento às atividades regulares, aprofundando conceitos e funcionando como
            eficiente retomada tanto para as provas do ENEM como para outros vestibulares
            de padrão similar.</p>
          <hr>
          <div class="d-block mx-auto">
            <h5 class="text-center font-weight-bolder text-uppercase">Para mais informações</h5>
            <p class="text text-center">
              Para mais informações sobre esse material, solicite hoje um consultor do Sistema de Ensino CPV.
            </p>
            <div class="d-flex justify-content-center">
              <b-button class="btn__consultor" :to="{ name: 'escolaParceira' }" variant="transparent">
                <i class="fa-regular fa-messages"></i>
                <span>Fale com um consultor</span>
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'ensino-infantil',
  components: { BreadSistema: () => import('../GlobalComponents/bread-sistema.vue') },
};
</script>

<style lang="scss" scoped>
#about__enem {
  background-color: #ffffff;

  #header {
    .img__header {
      background-image: url('https://sistemacpv2017.s3.amazonaws.com/wp-content/uploads/2019/10/11164045/imagem-para-enem_comprimida.jpg');
      background-repeat: no-repeat;
      background-position: center center;
    }
  }

  h5 {
    color: #e98b24;
  }

  p {
    font-size: 16px;
    line-height: 22px;
  }

  .lead {
    font-size: 20px;
    line-height: 26px;
    padding: 0;
    margin: 0;
  }

  .btn__consultor {
    display: inline-flex;
    min-width: auto;
    min-height: auto;

    margin: 0px auto 0;
    padding: 8px 16px;

    gap: 6px;

    background-color: #e98b24;
    border: 1px solid #e98b24;
    border-radius: 5px;

    display: flex;
    align-items: center;

    font-size: 14px;
    line-height: 20px;

    color: #fdf3e9;

    .icon {
      width: 18px;
      height: 18px;

      display: flex;
      align-items: center;

      i {
        font-size: 14px;
        line-height: 20px;
      }
    }

    &:hover {
      background-color: #d27d20;
      transition: all 0.3s ease-in-out;
      border: 1px solid #d27d20;
    }
  }
}

@media screen and (min-width: 1200px) {
  .content-text {
    padding-left: 32px;
    padding-right: 32px;
  }
}

@media screen and (min-width: 320px) and (max-width: 1200px) {
  .content-text {
    padding-left: 16px;
    padding-right: 16px;
  }
}
</style>
